export default{
    cadastra:{
        method:'post',
        url:'ferias/cadastro'
    },
    rescisaocadastra:{
        method:'post',
        url:'rescisao/contrato/tabela/cadastro'
    },
    rescisaoupdate:{
        method:'post',
        url:'rescisao/contrato/tabela/update'
    },
    delete:{
        method:'delete',
        url:'ferias/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'ferias/lista'
    },
    editar:{
        method:'get',
        url:'ferias/editar{/id}'
    },
    update:{
        method:'post',
        url:'ferias/update'
    },
    evento:{
        method:'get',
        url:'rescisaocontrato/evento/2200{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
}